export default __webpack_public_path__ + "static/media/330_business03-it-mobile.1d060b6e.png";